import { isEqual } from "lodash";
import { useEffect, useRef } from "react";

export function usePrevious(value: any) {
  const ref = useRef();
  useEffect(() => {
    if (!isEqual(value, ref.current)) {
      ref.current = value;
    }
  }, [value]);
  return ref.current;
}
